export default "__VITE_ASSET__06d802ae__"